import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * Whenever an editing session starts, kick off a fresh load so the form
 * is seeded from the latest persisted value rather than whatever stale
 * snapshot happens to be in the store.
 */
export const startEditingTriggerLoad = store.effects.create(
  (feature: Feature) =>
    feature.actions.startEditing.observe().pipe(
      rxjs.map(action =>
        feature.actions.load.from(action).create({
          agentId: action.data.agentId,
          conversationId: action.data.conversationId,
        }),
      ),
    ),
)
